<template>
    <div :class="['techInf',getPlatformClass,visible ? 'visible':'']">

         <div :class="['info', isTechFadeout === true ? 'infoFadeout' : '']">
          <div class="infItem" v-for="(item,index) in sectionData.contents" :key="index">
            <splitter :content="ms_localize(item)"></splitter>
          </div>
        </div>
 
         <div :class="['imgContainer', isTechFadeout === true ? 'techImgFadeout' : '']">
          <img class="itemImg" :src="infoImg" />
        </div>

        <div :class="['infPlatformBarContainer',plaformIndex>-1 ? 'mounted':'mounted']">
          <platformbar 
            v-bind:affectOtherSections = "false"
            v-bind:sectionIndex = "3"
            skinMode = "light"
            @platform-change="onPlatformChange" 
            @item-change="onItemChange">
          </platformbar>
        </div>

    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";
import platformbar from "@/views/com/platformbar.vue";
import splitter from "@/views/com/splitter.vue";

export default {
    name: "techInfo",
    components:{platformbar,splitter},
    props: {
        visible:Boolean,
        sectionDataIndex:Number,
        isNavOpen: Boolean
    },
    data()
    {
        return {
            plaformIndex:-1,
            infoImg:'',
            isTechFadeout:true
        }
    },
    watch: {
      '$store.state.xSelectedPlatform': function() {
        //alert("xP="+this.$store.state.xSelectedPlatform);
        this.onPlatformChange(this.$store.state.xSelectedPlatform);
      }
    },
    methods:
    {
      onPlatformChange(plaformIndex)
      {
        var vm = this;        
        vm.isTechFadeout = true;
        
        setTimeout(() => {
          vm.plaformIndex = plaformIndex;
          vm.infoImg = this.sectionData.platforms[plaformIndex].img;
        }, 500);

        setTimeout(() => {
          vm.isTechFadeout = false;
        }, 1100);

        //this.plaformIndex = plaformIndex;
        //this.infoImg = this.sectionData.platforms[plaformIndex].img;
      },
      onItemChange(catalogNo)
      {
        //nothing
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["xSelectedPlatform","minisite_data","siteDataReady"]),
        getStorePlatform()
        {
          return this.xSelectedPlatform;//
        },
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            return this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};

</script>


<style>
    @property --c {
      syntax: '<color>';
      inherits: false;
      initial-value: red;
    }
    .techInf
    {
        background: transparent;
        width: 100%;
        height: 100%;   
        position: relative;     
        display: block;
    }    
    .techInf.visible
    {
      display: block;
    }
    .techInf.platform_0{--c:#2a2512;}
    .techInf.platform_1{--c:#241128;}
    .techInf.platform_2{--c:#241128;}
    .techInf.platform_3{--c:#0f250e;}

    .techInf .container
    {
      width: 100vw;
    }
    .techInf .info
    {
        position:absolute;
        left: 0px;
        top: 20vh;
        opacity: 1;
        padding-left: 5vw;
        /* padding-left: calc(24vw / 2); */
    }
    .techInf .info.infoFadeout
    {
      opacity: 0;
    }

    .techInf .info .infItem:nth-child(1)
    {
      font-weight: bold;
    }
    .techInf .info .infItem
    {
      padding-top: 3px;
      font-size: 18px;
      text-align: left;        
      color: #202020;
    }


    .techInf .infPlatformBarContainer
    {
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      /* position: absolute;bottom: 30px; */
      width: 100%;
    }
    .techInf .infPlatformBarContainer.mounted
    {
      /* top:calc(100vh - 120px); */
      bottom: 30px;
    }    

    .techInf .imgContainer
    {
      /* position: absolute;top:43%;transform: translateY(-50%); */
      padding-top: 30px;
      width: 100%;text-align: center;
      color:#fff;
      pointer-events: none;
      opacity: 1;
      transition: all ease 0.8s;
    }
    .techInf .imgContainer.techImgFadeout
    {
      opacity: 0;
    }
    .techInf .imgContainer .itemImg
    {
      height: 26vw;width: auto;
    }
    .techInf .imgContainer .itemTitle
    {
      padding-top: 20px;
      font-size: 14px;color: #fff;font-weight: 300;text-align: center;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) { 
    .techInf
    {      
      min-height: 30vh;
      width: 100vw !important;
      height: auto;
      display: block;
      margin-bottom: 100px;      
    }    
    .techInf .title
    {
      position: initial;
      padding-top: 100px;
      padding-left: 10vw;
      text-align: left;
    }    
    .techInf .info
    {
        position:initial;
        padding-top: 30px;
        transform: none;
        padding-left: 10vw;
    }    
    .techInf .imgContainer
    {
        position: initial;
        transform:none;
        padding-top: 40px;
    }
    .techInf .infPlatformBarContainer
    {
      position: static;
      transform: translateY(0%);
      width: 100%;
      /* padding: 50px 0px 50px 0px; */
      padding: 50px 0px 0px 0px;
    }    
    .techInf .infPlatformBarContainer.mounted
    {

    }    

  }  
</style>